import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DishCard = ({ dish, onViewDetails, onAddToCart, onToggleFavorite }) => {
  const renderRatingStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Icon
        key={index}
        name={index < Math.floor(rating) ? 'Star' : 'StarHalf'}
        size={14}
        color={index < rating ? '#F59E0B' : '#D1D5DB'}
        className="fill-current"
      />
    ));
  };

  return (
    <div className="bg-card rounded-xl shadow-warm hover:shadow-warm-md transition-smooth overflow-hidden group">
      <div className="relative h-48 md:h-56 lg:h-64 overflow-hidden">
        <Image
          src={dish?.image}
          alt={dish?.imageAlt}
          className="w-full h-full object-cover group-hover:scale-105 transition-smooth"
        />
        <button
          onClick={() => onToggleFavorite(dish?.id)}
          className="absolute top-3 right-3 w-9 h-9 bg-card/90 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-card transition-smooth"
        >
          <Icon
            name="Heart"
            size={18}
            color={dish?.isFavorite ? 'var(--color-accent)' : 'var(--color-foreground)'}
            className={dish?.isFavorite ? 'fill-current' : ''}
          />
        </button>
        {dish?.isNew && (
          <div className="absolute top-3 left-3 px-3 py-1 bg-success text-success-foreground text-xs font-bold rounded-full">
            NEW
          </div>
        )}
        {dish?.discount && (
          <div className="absolute bottom-3 left-3 px-3 py-1 bg-accent text-accent-foreground text-xs font-bold rounded-full">
            {dish?.discount}% OFF
          </div>
        )}
      </div>
      <div className="p-4 md:p-5 lg:p-6">
        <div className="flex items-start justify-between gap-2 mb-2">
          <h3 className="font-heading font-semibold text-base md:text-lg line-clamp-1">
            {dish?.name}
          </h3>
          <div className="flex items-center gap-1 flex-shrink-0">
            {renderRatingStars(dish?.rating)}
          </div>
        </div>

        <p className="text-sm text-muted-foreground line-clamp-2 mb-3">
          {dish?.description}
        </p>

        <div className="flex items-center gap-2 mb-3">
          <div className="flex items-center gap-1.5">
            <Icon name="Store" size={16} color="var(--color-muted-foreground)" />
            <span className="text-sm text-muted-foreground line-clamp-1">
              {dish?.supplierName}
            </span>
          </div>
        </div>

        <div className="flex flex-wrap gap-2 mb-4">
          <span className="px-2.5 py-1 bg-primary/10 text-primary text-xs font-medium rounded-full">
            {dish?.cuisine}
          </span>
          {dish?.dietary?.map((diet, index) => (
            <span
              key={index}
              className="px-2.5 py-1 bg-success/10 text-success text-xs font-medium rounded-full flex items-center gap-1"
            >
              <Icon name="Leaf" size={12} />
              {diet}
            </span>
          ))}
        </div>

        <div className="flex items-center justify-between gap-3 pt-3 border-t border-border">
          <div>
            <p className="text-xs text-muted-foreground mb-0.5">Price per plate</p>
            <p className="text-xl md:text-2xl font-heading font-bold text-primary data-text">
              ${dish?.pricePerPlate}
            </p>
          </div>
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              iconName="Eye"
              onClick={() => onViewDetails(dish)}
            >
              View
            </Button>
            <Button
              variant="default"
              size="sm"
              iconName="ShoppingCart"
              onClick={() => onAddToCart(dish)}
            >
              Add
            </Button>
          </div>
        </div>

        {dish?.deliveryTime && (
          <div className="flex items-center gap-1.5 mt-3 pt-3 border-t border-border">
            <Icon name="Clock" size={14} color="var(--color-muted-foreground)" />
            <span className="text-xs text-muted-foreground">
              Delivery in {dish?.deliveryTime}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default DishCard;